import { DsFormTypeEnum } from '../../enums/ds-forms.enum';
import { DsFormMetadataField } from './ds-form-metadata-field.class';
import { DsFormMetadataFieldInterface } from '../../interfaces/form-fields/ds-form-metadata-field.interface';

export class DsFormDocument extends DsFormMetadataField {
  /**
   * Creates an instance of DsFormDocument.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsFormMetadataFieldInterface) {
    super(jsonData);
    this.type = DsFormTypeEnum.DOCUMENT;
  }
}
